module.exports = __webpack_public_path__ + "static/media/mmusician-lg-1.269c71f6.jpg";